"use client";

import { Add, Minus, Trash } from "iconsax-reactjs";
import { Button } from "@/components/ui";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface CartQuantityControlProps {
  quantity: number;
  onIncrement?: (e: React.MouseEvent) => void;
  onDecrement?: (e: React.MouseEvent) => void;
  max?: number;
  disabled?: boolean;
  incrementLoading?: boolean;
  decrementLoading?: boolean;
  size?: "sm" | "md";
  className?: string;
}

export const CartQuantityControl = ({
  quantity,
  onIncrement,
  onDecrement,
  max,
  disabled = false,
  incrementLoading = false,
  decrementLoading = false,
  size = "md",
  className,
}: CartQuantityControlProps) => {
  return (
    <div
      className={cn(
        "border border-stroke-subtle text-primary",
        size === "sm" ? "px-2 py-1 gap-3" : "px-3 py-2.5 gap-5",
        "flex items-center rounded-xs",
        { "opacity-50 cursor-not-allowed pointer-events-none": disabled },
        className,
      )}
    >
      <Button
        size={"icon"}
        variant={"light"}
        colors={"secondary"}
        className="p-0 opacity-100"
        disabled={quantity >= (max || Infinity) || incrementLoading}
        type="button"
        onClick={(e) => {
          onIncrement?.(e);
        }}
      >
        {incrementLoading ? (
          <Spinner
            className={cn(
              "text-text-primary size-5",
              size === "sm" ? "size-4" : "size-5",
            )}
          />
        ) : (
          <Add size={size === "sm" ? 16 : 20} className="text-text-primary" />
        )}
      </Button>
      <p
        className={cn(
          "font-semibold mt-0.5",
          size === "sm" ? "text-xs" : "text-base",
        )}
      >
        {quantity}
      </p>
      <Button
        disabled={decrementLoading}
        size={"icon"}
        variant={"light"}
        colors={"secondary"}
        className="p-0 opacity-100"
        type="button"
        onClick={(e) => {
          onDecrement?.(e);
        }}
      >
        {decrementLoading ? (
          <Spinner
            className={cn(
              "text-text-primary",
              size === "sm" ? "size-4" : "size-5",
            )}
          />
        ) : quantity <= 1 ? (
          <Trash size={size === "sm" ? 16 : 20} className="text-text-primary" />
        ) : (
          <Minus size={size === "sm" ? 16 : 20} className="text-text-primary" />
        )}
      </Button>
    </div>
  );
};
